import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import LanguageDialog from "./LanguageDialog";
import { isEmpty } from "lodash";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { useTranslation } from "react-i18next";


const MENU_ITEMS = [
  {
    href: "/",
    labelKey: "Home",
    icon: "/static/svg/mobileMenu/home.png",
    altKey: "AltJaya9Cricket",
  },
  {
    href: "/casino?type=cricket",
    labelKey: "Cricket",
    icon: "/static/svg/mobileMenu/cricket.png",
    altKey: "AltJaya9Exchange",
  },
  {
    href: "/casino?type=casino",
    labelKey: "LiveCasino",
    icon: "/static/svg/mobileMenu/ld.png",
    altKey: "AltJaya9Exchange",
  },
  {
    href: "/casino?type=slot",
    labelKey: "SlotGames",
    icon: "/static/svg/mobileMenu/rng.png",
    altKey: "AltJaya9Exchange",
  },
  {
    href: "/casino?type=table",
    labelKey: "TableGames",
    icon: "/static/svg/mobileMenu/table.png",
    altKey: "AltJaya9Exchange",
  },
  {
    href: "/casino?type=sportbook",
    labelKey: "Sportbook",
    icon: "/static/svg/mobileMenu/sb.png",
    altKey: "AltJaya9Exchange",
  },
  {
    href: "/casino?type=fishing",
    labelKey: "Fishing",
    icon: "/static/svg/mobileMenu/fishing.png",
    altKey: "AltJaya9Exchange",
  },
  {
    href: "/casino?type=crash",
    labelKey: "Crash",
    icon: "/static/svg/mobileMenu/crash.png",
    altKey: "AltJaya9Exchange",
  },
  {
    href: "/promotion",
    labelKey: "Promotion",
    icon: "/static/svg/mobileMenu/promo.png",
    altKey: "AltJaya9Promotion",
    standalone: true,
  },
  {
    href: "/referral",
    labelKey: "Referral",
    icon: "/static/svg/mobileMenu/referral.png",
    altKey: "AltJaya9Referral",
  },
];

const SideNavDrawer = ({ open, onClose }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [showLanguage, setShowLanguage] = useState(false);
  const drawerRef = useRef(null);
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const logoutUser = useContextSelector(AuthContext, (ctx) => {
    return ctx.logoutUser;
  });
  const isActive = (href) => location.pathname === href;

  // ---- Close on outside click ----
  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (e) => {
      // ignore clicks while the language dialog is open, and clicks inside the drawer itself
      if (showLanguage) return;
      if (drawerRef.current && !drawerRef.current.contains(e.target)) {
        onClose?.();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [open, showLanguage, onClose]);

  return (
    <>
      {/* ---- Backdrop (also closes the drawer on click, and dims the page) ---- */}
      {open && (
        <div
          className="v-overlay theme--dark"
          style={{
            zIndex: 200,
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(33, 33, 33, 0.46)",
          }}
          onClick={onClose}
        />
      )}

      <aside
        ref={drawerRef}
        className={
          "side-navigation-drawer v-navigation-drawer v-navigation-drawer--fixed v-navigation-drawer--is-mobile v-navigation-drawer--temporary theme--light" +
          (open ? " v-navigation-drawer--open" : "")
        }
        left=""
        data-booted="true"
        style={{
          height: "100%",
          top: "0px",
          transform: open ? "translateX(0%)" : "translateX(-100%)",
          width: "60%",
          zIndex: 201,
          position: "fixed",
        }}
      >
        <div className="v-navigation-drawer__content">
          <div
            role="list"
            className="v-list mobile_list_menu v-sheet theme--light v-list--nav"
          >
            <div
              role="listbox"
              className="v-item-group theme--light v-list-item-group"
            >
              {/* ---- Logo ---- */}
              <div
                tabIndex={0}
                role="option"
                aria-selected="false"
                className="side-nav-logo v-list-item v-list-item--link theme--light"
              >
                <div
                  aria-label=""
                  className="v-image v-responsive theme--light"
                  style={{ maxWidth: "120px" }}
                >
                  <div
                    className="v-responsive__sizer"
                    style={{ paddingBottom: "29.8687%" }}
                  />
                  <div
                    className="v-image__image v-image__image--contain"
                    style={{
                      backgroundImage: `url("/static/image/home/logo3.png")`,
                      backgroundPosition: "center center",
                    }}
                  />
                  <div
                    className="v-responsive__content"
                    style={{ width: "914px" }}
                  />
                </div>
              </div>

              {/* ---- Menu items ---- */}
              {MENU_ITEMS.map((item) => (
                <Link
                  key={item.href}
                  to={item.href}
                  onClick={onClose}
                  className={
                    (item.standalone ? "list-item-standalone " : "") +
                    "v-list-item v-list-item--link theme--light" +
                    (isActive(item.href) ? " v-list-item--active" : "")
                  }
                  tabIndex={0}
                  role="option"
                  aria-selected={isActive(item.href)}
                >
                  <div className="row list-item-container no-gutters">
                    <div className="v-list-item__icon side-menu-icon-wrapper">
                      <img
                        src={item.icon}
                        alt={t(item.altKey)}
                        className="side-menu-icon"
                      />
                    </div>
                    <div className="v-list-item__content">
                      <div className="v-list-item__title">{t(item.labelKey)}</div>
                    </div>
                  </div>
                </Link>
              ))}
              {!isEmpty(user) && (
                <div
                onClick={() => logoutUser()}
                  tabIndex={0}
                  role="option"
                  aria-selected="false"
                  className="v-list-item v-list-item--link theme--light"
                >
                  <div className="row list-item-container no-gutters">
                    <div className="v-list-item__icon">
                      <img
                        src="/static/svg/mobileMenu/logout.svg"
                        alt={t("AltJaya9CrazytimeExchange")}
                        className="side-menu-icon"
                      />
                    </div>
                    <div className="v-list-item__content">
                      <div className="v-list-item__title">{t("Logout")}</div>
                    </div>
                  </div>
                </div>
              )}

              <div
                tabIndex={0}
                role="option"
                aria-selected="false"
                onClick={() => setShowLanguage(true)}
                className="v-list-item v-list-item--link theme--light"
              >
                <div className="row list-item-container no-gutters">
                  <div className="v-list-item__icon side-menu-icon-wrapper ml-1 mt-3">
                    <div
                      className="v-avatar language-button"
                      style={{
                        height: "30px",
                        minWidth: "30px",
                        width: "30px",
                      }}
                    >
                      <img
                        src="/static/image/country/BDT.svg"
                        alt={t("AltJaya9CricketExchange")}
                      />
                    </div>
                  </div>
                  <div className="v-list-item__content pl-1">
                    <div className="v-list-item__title">{t("Language")}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="v-navigation-drawer__border" />
      </aside>

      {showLanguage && <LanguageDialog setLanguage={setShowLanguage} />}
    </>
  );
};

export default SideNavDrawer;
